<template>
  <div>
    <div style="min-height: 85vh !important" class="pa-4">
      <vue-element-loading :active="visible" :is-full-screen="true" />
      <div class="row">
        <div class="flex md12">
          <p class="text-left poppinsbold" style="font-size: 22px !important">
            ADDING ANALYST DETAILS
          </p>
          <form @submit="onsubmit" enctype="multipart/form-data">
            <b-row>
              <b-col cols="12" md="12" class="pt-3">
                <span class="poppinsregular" style="font-size: 14px">
                  Name</span
                >
                <b-form-input
                  type="text"
                  required
                  class="poppinsregular form-control"
                  style="font-size: 14px"
                  v-model="analyst.name"
                  placeholder=" Name"
                ></b-form-input>
              </b-col>

              <b-col cols="12" md="12" class="pt-3">
                <span class="poppinsregular" style="font-size: 14px">
                  Email ID
                </span>
                <b-form-input
                  type="text"
                  required
                  class="poppinsregular form-control"
                  style="font-size: 14px"
                  v-model="analyst.email"
                  placeholder=" Email"
                ></b-form-input>
              </b-col>
              <b-col cols="12" md="12" class="pt-3">
                <span class="poppinsregular" style="font-size: 14px">
                  Mobile Number
                </span>
                <b-form-input
                  type="number"
                  required
                  class="poppinsregular form-control"
                  style="font-size: 14px"
                  v-model="analyst.phone"
                  placeholder=" Phone"
                ></b-form-input>
              </b-col>

              <!-- <b-col cols="12" md="12" class="pt-3">
                <span class="poppinsregular" style="font-size: 14px">
                  Upload User Profile Picture:
                </span>
                <output>
                  <img
                    :src="previewUrl"
                    v-if="previewUrl"
                    style="width: 150px; height: 150px"
                  />
                </output>
                <input
                  type="file"
                  id="file"
                  accept="image/*"
                  v-on:change="uploadImage($event)"
                />
              </b-col> -->
            </b-row>

            <b-row align-h="right" class="py-4">
              <b-col cols="3">
                <b-button type="submit" class="px-4 themebtncolor">
                  Submit
                </b-button>
              </b-col>
              <b-col cols="3">
                <b-button @click="emitterFunc" variant="danger" class="px-4">
                  Cancel
                </b-button>
              </b-col>
            </b-row>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import VueElementLoading from 'vue-element-loading'
export default {
  name: 'login',
  components: {
    VueElementLoading,
  },
  data () {
    return {
      previewUrl: '',
      visible: false,
      analyst: {
        name: null,
        email: null,
        phone: null,
      },

      message: '',
      isView: false,
      msg: '',
      photo: '',
    }
  },
  //   mounted: function () {
  //     this.getList();
  //   },

  methods: {
    emitterFunc () {
      this.$emit('stepper', {
        addAnalystModal: false,
      })
    },
    uploadImage () {
      this.selectedFile = event.target.files[0]
      this.url = URL.createObjectURL(this.selectedFile)
      const file = event.target.files[0]
      if (file) {
        this.stat = 1
      } else {
        this.stat = 0
        return false
      }
      if (!file.type.match('image.*')) {
        // return false
        this.stat = 0
      } else {
        this.stat = 1
      }
      const reader = new FileReader()
      const that = this
      reader.onload = function (e) {
        that.previewUrl = e.target.result
      }
      reader.readAsDataURL(file)
    },
    onsubmit (evt) {
      this.visible = true
      evt.preventDefault()
      axios({
        method: 'POST',
        url: '/add/admin',
        data: this.analyst,
        headers: {
          token: localStorage.getItem('token'),
        },
      })
        .then((response) => {
          this.visible = false
          // this.status = response.data.status;
          this.msg = response.data.msg
          if (response.data.status) {
            this.$bvToast.toast(response.data.msg, {
              title: 'status',
              autoHideDelay: 3000,
              variant: 'success',
            })
            this.$emit('stepper', {
              addAnalystModal: false,
            })
          } else {
            this.$bvToast.toast(response.data.msg, {
              title: 'status',
              autoHideDelay: 5000,
              variant: 'danger',
            })
            this.$emit('stepper', {
              addAnalystModal: false,
            })
          }
        })
        .catch((e) => {
          console.log(e)
        })
    },
  },
}
</script>
